import { useState, useEffect, useRef } from 'react';

function useAspectRatio() {
  const [ratio, setRatio] = useState(null);
  const ref = useRef(null);

  useEffect(() => {
    const updateRatio = () => {
      if (ref.current) {
        const { clientWidth, clientHeight } = ref.current;
        if (clientWidth && clientHeight) {
          setRatio(clientWidth / clientHeight);
        }
      }
    };

    updateRatio();

    // Recalculate ratio when the window is resized
    window.addEventListener('resize', updateRatio);
    
    return () => {
      window.removeEventListener('resize', updateRatio);
    };
  }, []);

  return [ref, ratio];
}

function isRatioSimilar(ratio1, ratio2, tolerance = 0.1) {
    if(ratio1 === 0 || ratio2 === 0) return false;
    const difference = Math.abs(ratio1 - ratio2);
    return difference <= tolerance * ratio1;
}

function getScaleRatio(ratio, containerRatio){
    if(!ratio || !containerRatio) return null;
    const calculatedRatio = (ratio > containerRatio) ? (ratio / containerRatio) : (containerRatio / ratio);
    return Math.round(calculatedRatio * 100) / 100;
}

export { isRatioSimilar, getScaleRatio };

export default useAspectRatio;